module.exports = __webpack_public_path__ + "static/media/top-slide-4.09f304c6.webp";